import SuratJalanSupplyForSubcontract from '@/models/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontract';

export default class SuratJalanSupplyForSubcontractFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.suratJalanNo = '';
		this.workOrderSupplySubcontractId  = '';
		this.workOrderSupplySubcontractMaterialIssueNumber = '';
		this.deliveryDateFrom = '';
		this.deliveryDateTo = '';
		this.isAlreadyDelivered = false;
		this.purchaseOrderId  = '';
		this.purchaseOrderPurchaseOrderNumber = '';
		this.vendorId  = '';
		this.vendorCode = '';
		this.driverName = '';
		this.vehicleNumber = '';
		this.picSuratJalan = '';
		this.adminSuratJalan = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			suratJalanNo : '0',
			workOrderSupplySubcontractId : '0',
			workOrderSupplySubcontractMaterialIssueNumber : '0',
			deliveryDateFrom : '0',
			deliveryDateTo : '0',
			isAlreadyDelivered : '0',
			purchaseOrderId : '0',
			purchaseOrderPurchaseOrderNumber : '0',
			vendorId : '0',
			vendorCode : '0',
			driverName : '0',
			vehicleNumber : '0',
			picSuratJalan : '0',
			adminSuratJalan : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}